export const appDownloadLinks = {
  appStore: 'https://apps.apple.com/app/apple-store/id1463386686?pt=119067375',
  googlePlay:
    'https://play.google.com/store/apps/details?id=com.fitifyworkouts.bodyweight.workoutapp',
  lfg: 'https://fitify.app/lfg',
}

export const footerLinks = {
  privacyPolicy: {
    href: 'https://gofitify.com/privacy-policy',
    translate: 'common_privacy_policy',
  },
  terms: {
    href: 'https://gofitify.com/terms',
    translate: 'common_terms_of_service',
  },
}

export const contactInfo = {
  supportEmail: 'support@gofitify.com',
}
